module.exports = __webpack_public_path__ + "static/media/squareDisabled.507a36bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/squareDisabled.svg
// module id = 1025
// module chunks = 43